import { Link } from 'react-router-dom';

const MERCH_ITEMS = [
  {
    id: 'm1',
    name: "Dirty Birdy Logo — Men's Premium T-Shirt",
    price: '$26.99',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T812A1269PA4267PT17X48Y66D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=1269/dirty-birdy-logo-mens-premium-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=812&sellable=J1LBzMg1dxHpM8Jla8ja-812-7&appearance=1269',
  },
  {
    id: 'm2',
    name: "Dirty Birdy Logo — Women's Premium T-Shirt",
    price: '$26.99',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T813A1PA4249PT17X14Y47D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=1/dirty-birdy-logo-womens-premium-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=813&sellable=J1LBzMg1dxHpM8Jla8ja-813-8&appearance=1',
  },
  {
    id: 'm3',
    name: "Dirty Birdy Logo — Women's T-Shirt",
    price: '$23.49',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T347A4PA4306PT17X1Y48D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=4/dirty-birdy-logo-womens-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=347&sellable=J1LBzMg1dxHpM8Jla8ja-347-8&appearance=4',
  },
  {
    id: 'm4',
    name: "Dirty Birdy Logo — Men's Hoodie",
    price: '$41.49',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T111A2PA4247PT17X49Y47D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=2/dirty-birdy-logo-mens-hoodie.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=111&sellable=J1LBzMg1dxHpM8Jla8ja-111-22&appearance=2',
  },
  {
    id: 'm5',
    name: "Dirty Birdy Logo — Unisex Tri-Blend Organic Tank",
    price: '$25.49',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T2380A2PA4450PT17X2Y69D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=2/dirty-birdy-logo-unisex-tri-blend-organic-tank.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=2380&sellable=J1LBzMg1dxHpM8Jla8ja-2380-15&appearance=2',
  },
  {
    id: 'm6',
    name: "Dirty Birdy Logo — Men's T-Shirt",
    price: '$23.49',
    imageUrl: 'https://image.spreadshirtmedia.com/image-server/v1/products/T347A4PA4306PT17X1Y48D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=4/dirty-birdy-logo-womens-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=210&sellable=J1LBzMg1dxHpM8Jla8ja-210-7&appearance=120',
  },
];

export default function MerchPreview() {
  return (
    <section className="bg-brand-dark py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="font-heading font-light text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">Official Merch</p>
            <h2 className="font-display text-5xl md:text-6xl text-white tracking-wide">
              THE <span className="text-brand-yellow">STORE</span>
            </h2>
          </div>
          <Link to="/store" className="whitespace-nowrap font-heading font-semibold text-xs tracking-widest uppercase text-brand-yellow border border-brand-yellow px-6 py-2.5 hover:bg-brand-yellow hover:text-black transition-colors duration-200 cursor-pointer">
            Shop All
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {MERCH_ITEMS.map((item) => (
            <a
              key={item.id}
              href={item.href}
              target="_blank"
              rel="nofollow noreferrer"
              className="group bg-brand-card overflow-hidden cursor-pointer block"
            >
              <div className="relative w-full h-0 pb-[100%] overflow-hidden bg-white">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="absolute inset-0 w-full h-full object-contain object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex items-center justify-between">
                <div>
                  <h3 className="font-heading font-semibold text-white text-base">{item.name}</h3>
                  <p className="font-display text-brand-yellow text-xl mt-1">{item.price}</p>
                </div>
                <div className="whitespace-nowrap w-10 h-10 flex items-center justify-center bg-brand-yellow hover:bg-brand-orange transition-colors duration-200 cursor-pointer">
                  <i className="ri-shopping-bag-line text-black text-base" />
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="mt-10 text-center">
          <p className="font-body text-white/40 text-sm">Powered by <strong className="text-brand-orange">Spreadshop</strong> — Print on demand, shipped worldwide</p>
        </div>
      </div>
    </section>
  );
}
